import { Action } from '@ngrx/store';

export class UsersAction implements Action {

    public static login: string = '[Login] login';
    public static loginSuccess: string = '[Login] login_success';
    public static loginError: string = '[Login] login_error';
    public static loginDenied: string = '[Login] login_denied';
    public static loginCancel: string = '[Login] login_cancel';

    public static requestUpdatedCblc: string = '[Account] request_updated_cblc';
    public static requestUpdatedCblcSuccess: string = '[Account] request_updated_cblc_success';
    public static requestUpdatedCblcError: string = '[Account] request_updated_cblc_error';

    // quando o usuário precisa informar um token para logar
    public static tokenRequired: string = '[Login] token_required';
    public static authenticateUserUsingToken: string = '[Login] authenticate_user_using_token';
    public static authenticateUserUsingTokenFromWebApp: string = '[Login] authenticate_user_using_token_from_web_app';
    public static authenticateUserUsingTokenFromRegister: string = '[Login] authenticate_user_using_token_from_register';

    // logout
    public static logout: string = '[Logout] logout';
    public static logoutError: string = '[Logout] logout_error';
    public static logoutSuccess: string = '[Logout] logout_success';
    public static resetCurrentUser: string = '[Logout] reset_current_user';

    public static changePassword: string = '[Password] change';
    public static changePasswordError: string = '[Password] change_error';
    public static changePasswordSucess: string = '[Password] change_sucess';

    public static accountSelectRequired: string = '[Account] account_select_required';

    public static sendForgotPasswordEmail: string = '[Password] send_forgot_password_email';
    public static validateTokenForgotPasswordEmail: string = '[Password] validate_token_forgot_password_email';
    public static validateTokenForgotPasswordEmailSuccess: string = '[Password] validate_token_forgot_password_email_success';
    public static validateTokenForgotPasswordEmailError: string = '[Password] validate_token_forgot_password_email_error';
    public static forgotPasswordToken: string = '[Password] forgot_password_token';
    public static forgotPasswordEmailSendingError: string = '[Password] forgot_password_email_sending_error';
    public static forgotPasswordEmailSuccefulySent: string = '[Password] forgot_password_email_sent';

    public static recoverPassword: string = '[Password] recover_password';
    public static recoverPasswordError: string = '[Password] recover_password_error';
    public static recoverPasswordSuccess: string = '[Password] recover_password_success';

    public static loginAttempt: string = '[Authorization] login_attempt';

    // requisitar e-mail de desbloqueio de conta
    public static requestUnlockAccountEmail = '[Authorization] request_unlock_account_email';
    public static requestUnlockAccountEmailSuccess = '[Authorization] request_unlock_account_email_success';
    public static requestUnlockAccountEmailError = '[Authorization] request_unlock_account_email_error';

    // desbloqueio de conta
    public static unlockAccount = '[Authorization] unlock_account';
    public static unlockAccountError = '[Authorization] unlock_account_error';
    public static unlockAccountSuccess = '[Authorization] unlock_account_success';
    public static secondFactorNeddedToUnlockAccount = '[Authorization] second_factor_needed_to_unlock_account';

    // ultima modificação da senha
    public static getLastModifiedPasswordDate = '[Authorization] get_last_modified_password_date';
    public static getLastModifiedPasswordDateError = '[Authorization] get_last_modified_password_date_error';
    public static getLastModifiedPasswordDateSucess = '[Authorization] get_last_modified_password_date_success';

    // ultima modificação da senha
    public static getHasDevice = '[Authorization] get_has_device';
    public static getHasDeviceError = '[Authorization] get_has_device_error';
    public static getHasDeviceSuccess = '[Authorization] get_has_device_success';

    // pegar session id pra usuario deslogado
    public static getSessionID = '[Authorization] get_session_id';
    public static saveSessionID = '[Authorization] save_session_id';
    public static getSessionIDError = '[Authorization] get_session_id_error';
    public static getSessionIDSuccess = '[Authorization] get_session_id_success';

    // reseta informações do erro
    public static resetErrorData = '[Authentication] reset_error_data';

    public static setCurrentUserByToken = '[Authentication] set_current_user_by_token';

    // origem da plataforma
    public static setPlatform = '[Authentication] set_platform';
    public static getPlatform = '[Authentication] get_platform';

    // usuário recebeu 401, a caixa de login foi apresentada e não houve sucesso ao autenticar
    public static forcedAuthenticationFailed = '[Authentication] forced_authentication_failed';
    public static forcedAuthenticationSuccefully = '[Authentication] forced_authentication_succefully';

    public static isUserLogin = '[Authentication] is_user_login';

    public static clearMonthlyToken: string = '[Authentication] clear_monthly_token';

    public static tokenError: string = '[Authentication] token_error';

    public static realtimeTokenReceivedSuccess: string = '[RealtimeToken] received_success';

    public static getUserCblc: string = '[User] get_cblc_array'
    public static getUserCblcArraySuccess: string = '[User] get_cblc_array_success'
    public static getUserCblcArrayError: string = '[User] get_cblc_array_error'


    constructor(
        public type: string,
        public payload?: any,
    ) { }
}
